export const telegramServer = {
    baseURL: "https://telegram-bot-api.steady.darvis.dev",
    shortUrlbaseURL: "https://urlshortener-api.steady.darvis.dev",
  }